export default "__VITE_ASSET__CXGQmXAd__"